export default __webpack_public_path__ + "64e70f849409e768a72bed20d9a8c363.png";